(function() {
  'use strict';

  var FUNCTIONS_URL = 'https://europe-west1-everything-tea.cloudfunctions.net/wholesaleEnquiry';

  var form = document.getElementById('et-wholesale-form');
  if (!form) return;

  var submitBtn = document.getElementById('ws-submit-btn');
  var btnText = submitBtn.querySelector('.btn-text');
  var btnLoading = submitBtn.querySelector('.btn-loading');
  var successEl = document.getElementById('et-wholesale-success');
  var errorEl = document.getElementById('et-wholesale-error');

  var requiredFields = [
    { id: 'ws-business-name', name: 'businessName' },
    { id: 'ws-contact-person', name: 'contactPerson' },
    { id: 'ws-email', name: 'email' },
    { id: 'ws-phone', name: 'phone' },
    { id: 'ws-business-type', name: 'businessType' },
    { id: 'ws-city-region', name: 'cityRegion' }
  ];

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function clearErrors() {
    var errorFields = form.querySelectorAll('.error');
    for (var i = 0; i < errorFields.length; i++) {
      errorFields[i].classList.remove('error');
    }
    errorEl.style.display = 'none';
  }

  function setLoading(loading) {
    submitBtn.disabled = loading;
    btnText.style.display = loading ? 'none' : '';
    btnLoading.style.display = loading ? '' : 'none';
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    clearErrors();

    // Validate required fields
    var valid = true;
    var payload = {};

    for (var i = 0; i < requiredFields.length; i++) {
      var field = requiredFields[i];
      var el = document.getElementById(field.id);
      var value = (el.value || '').trim();

      if (!value) {
        el.classList.add('error');
        valid = false;
      } else {
        payload[field.name] = value;
      }
    }

    // Validate email format
    if (payload.email && !validateEmail(payload.email)) {
      document.getElementById('ws-email').classList.add('error');
      valid = false;
    }

    if (!valid) return;

    // Add optional message
    var messageEl = document.getElementById('ws-message');
    if (messageEl && messageEl.value.trim()) {
      payload.message = messageEl.value.trim();
    }

    // Add honeypot
    var honeypotEl = form.querySelector('input[name="_honeypot"]');
    if (honeypotEl && honeypotEl.value) {
      payload._honeypot = honeypotEl.value;
    }

    setLoading(true);

    fetch(FUNCTIONS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Request failed');
      return response.json();
    })
    .then(function() {
      form.style.display = 'none';
      successEl.style.display = 'block';
      window.scrollTo({
        top: successEl.offsetTop - 100,
        behavior: 'smooth'
      });
    })
    .catch(function() {
      errorEl.style.display = 'block';
      setLoading(false);
    });
  });
})();
